'use strict'

import { Crossword } from './crossword.js'
import { Cell, Clue } from './grid.js'

export class PzlJson extends Crossword {
  /**
   * Initialize the PZL SVG puzzle.
   *
   * @param data [Buffer] the puzzle as a Uint8Array buffer.
   */
  constructor (data = new ArrayBuffer()) {
    super(data)
  }

  _parsePuzzle () {
    this._convertPuzzleToJson()
    this._setPuzzleData()
    this._setDims()
    this._setCells()
    this._setClues()

    return this
  }

  /**
   * Convert the data to a manageable JSON object.
   */
  _convertPuzzleToJson () {
    let str = new TextDecoder('utf-8').decode(this._data)

    if (str) {
      this._json = JSON.parse(str)
      this._jsonAttributes = this._json.data.attributes
    }
  }

  _setCells () {
    const puzzleAnswers = this._jsonAttributes.puzzle_answers

    this._prepopulateGrid()

    for (let i = 0, len = puzzleAnswers.length; i < len; i++) {
      const answer = puzzleAnswers[i]

      let cellLen = answer.cells.length
      for (let j = 0; j < cellLen; j++) {
        const cell = answer.cells[j]

        const coords = this._getCoordsFromCellId(cell.id)
        const idx = this.grid.idxFromCoords(coords.x, coords.y, coords.z)

        this.grid.cells[idx] = new Cell({
          answer: cell.solution,
          // 'cellNumber': (cellNumber ? parseInt(cellNumber) : ''),
          idx: idx,
          x: coords.x,
          y: coords.y,
          z: coords.z
        })
      }
    }

    this._setCellNumbers()
  }

  _setClues () {
    const clues = this._jsonAttributes.puzzle_answers
    for (let i = 0, len = clues.length; i < len; i++) {
      const clue = clues[i]
      const cells = this._getClueCells(clue)
      const x = clue.x
      const y = clue.y
      const z = clue.z

      this.clues.push(
        new Clue({
          'cells': cells,
          'clueString': clue.clueText,
          'idx': this.grid.idxFromCoords(x, y),
          'clueNumber': cells[0].cellNumber,
          'x': x,
          'y': y,
          'z': z
        })
      )
    }

    this._setAxes()
  }

  _setAxes () {
    this.axes = [...new Set(
      this.clues.map(clue => clue.axis)
    )]

    console.log('AXES')
    console.log(this.axes)
  }

  _getClueCells (clue) {
    const coords = this._getClueCoords(clue)
    return this.grid.cellsByCoords(
      coords
    )
  }

  _getClueCoords (clue) {
    return clue.cells.map(
      (cell) => {
        const cellCoords = this._getCoordsFromCellId(cell.id)

        return [
          cellCoords.x,
          cellCoords.y,
          cellCoords.z
        ]
      }
    )
  }

  // This pre-populates the grid with all blocks, so we only have
  // to deal with non-block cells.
  _prepopulateGrid () {
    const gridSize = this.grid.width * this.grid.height

    let cells = []
    for (let i = 0; i < gridSize; i++) {
      const coords = this.grid.coordsFromIdx(i)

      cells.push(new Cell({
        idx: i,
        cellType: 'block',
        x: coords.x,
        y: coords.y,
        z: coords.z
      }))
    }

    this.grid.cells = cells
  }

  _setDims () {
    this.grid.height = parseInt(
      this._jsonAttributes.size.height
    )

    this.grid.width = parseInt(
      this._jsonAttributes.size.width
    )
  }

  _getCoordsFromCellId (id) {
    const coords = id.split(/[_-]/).filter((item) => {
      return item !== 'cell'
    })

    return {
      x: parseInt(coords[0]),
      y: parseInt(coords[1]),
      z: parseInt(coords[2])
    }
  }

  _setPuzzleData () {
    // Metadata
    let metadataAttrs = {
      'copyright': 'copyright',
      'creator': 'author',
      'notepad': 'notepad',
      'title': 'name'
    }

    let xwKey
    Object.keys(metadataAttrs).forEach(key => {
      xwKey = metadataAttrs[key]

      this[key] = this._jsonAttributes[xwKey]
    })
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/pzl-tools/lib/pzl_json.js
// module id = 623
// module chunks = 0